// extracted by mini-css-extract-plugin
export default {"dividerContainer":"DJXCuKMZj4AhutZdQwGC","dividerLine":"hPUG05O67zzhE7BaNQoQ","dividerText":"ByyZ_WM1LYxUdJhgE5sL"};